export interface SelectBoxModel {
  name: string;
  value: string;
}
